// @flow strict

import * as React from 'react';

type PropTypes = {|
  tombstones: [],
|};

export const TombstoneCarouselBase = (props: { ...PropTypes }) => {
  return (
    <div className="devotion-tombstone-carousel">
      <div className="inner">
        <div className="swiper">
          <div className="swiper-wrapper">
            {props.tombstones.map(tombstone => (
              <div className="swiper-slide">
                <div className="label">{tombstone.label}</div>
                <div className="logo">
                  <img src={`${tombstone.imageUrl}`} alt={`${tombstone.label}`} />
                </div>
                <div className="title">{tombstone.title}</div>
                <div className="copy">{tombstone.summary}</div>
                {typeof tombstone.cta !== 'undefined' && tombstone.cta !== null && (
                  <div className="cta">
                    <a href={`${tombstone.cta.url}`} target={`${tombstone.cta.target}`}>
                      {tombstone.cta.label}
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="swiper-button-prev">
          <img src="/Content/images/carousel-pagination-prev.png" alt="prev" />
        </div>
        <div className="swiper-button-next">
          <img src="/Content/images/carousel-pagination-next.png" alt="next" />
        </div>
      </div>
    </div>
  );
};

const TombstoneCarousel = (props: PropTypes) => <TombstoneCarouselBase {...props} />;

export default TombstoneCarousel;
